export const GOOGLE_API_KEY = "AIzaSyDsufi5UzlumQ6oa53lCTL6TU7PtHBbuTA";

export const OFFSET_LIVE_CHAT = 25;

export const YOUTUBE_VIDEO_API = "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=REGION&key=" + GOOGLE_API_KEY;

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";
